import React from "react";
/* img imports */
import tent from "../assets/images/tents/main-tent.png";
import arrow from "../assets/images/tents/tent-forward-arrow.png";

const Tent = ({ handleRedirect }) => {
  return (
    <>
      <div className="tent-wrapper">
        <img src={tent} alt="" />
      </div>
      <div
        className="tent-door-wrapper"
        onClick={() => {
          handleRedirect("/inner-tents");
        }}
      >
        <img src={arrow} alt="" className="arrow-icon" />
        <img src={arrow} alt="" className="arrow-icon-outside" />
      </div>
      <div className="tent-text-wrapper"></div>
    </>
  );
};

export default Tent;
